<template>
	<div>
		<div class="i-content flex-row" v-if='inputStyle == "goodsDetail"'>
			<input class="i-input" v-model="currentValue" @blur="handleBlur"></input>
			<div class="flex-col">
				<span class="i-span" @click="increase"> <i class="el-icon-plus"></i></span>
				<span class="i-span" @click="decrease"> <i class="el-icon-minus"></i></span>
			</div>
		</div>
		<div :class="{'i-horizontal-content':true, 'disabled-input':disabled}" v-else>
			<span class="i-span-horizontal horizontal-left" @click="decrease"> <i class="el-icon-minus"></i></span>
			<input :disabled='disabled' class="i-input i-input-horizontal" v-model="currentValue" @blur="handleBlur"></input>
			<span class="i-span-horizontal horizontal-right" @click="increase"> <i class="el-icon-plus"></i></span>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'input-number',
		props: {
			max: {
				type: Number,
				default: Infinity
			},
			min: {
				type: Number,
				default: -Infinity
			},
			step: {
				type: Number,
				default: 1
			},
			curval: {
				type: Number,
				default: 0
			},
			isTimedSaleSpec: {
				type: Boolean,
				default: false
			},
			inputStyle: {
				type: String,
				default: 'goodsDetail' // goodsDetail竖向加减 shopcart横向加减
			},
			disabled: {
				type: Boolean,
				default: false
			},
			cartId: {
				type: Number
			},
		},
		watch: {
			//监听父组件传值
			curval(newValue, oldValue) {
				this.currentValue = newValue;
			},
			step(newValue, oldValue) {
				this.step = newValue;
			}
		},
		data() {
			return {
				currentValue: this.curval
			}
		},
		methods: {
			increase() {
				if (this.disabled) {
					return
				}

				let newVal = this.currentValue === 0 ? this.min : this.currentValue + this.step;
				this.setCurrentValue(newVal, true);
			},
			decrease() {
				if (this.disabled) {
					return
				}

				let newVal = this.currentValue - this.step;
				this.setCurrentValue(newVal);
			},
			handleBlur(e) {
				let value = e.target.value;
				let newVal = value.replace(/[^\d]/g, "");
				if (!newVal) {
					this.currentValue = this.min;
				} 
				// else if ((newVal - this.min) % this.step > 0) {
				// 	this.$message.error("购买数量必须为单次购买量" + this.step + "的倍数加最小起购量" + this.min)
				// 	this.currentValue = this.min + this.step * parseInt((newVal - this.min) / this.step);
				// }

				this.setCurrentValue(this.currentValue);
			},
			setCurrentValue(newVal, isPlus) {
				newVal = parseInt(newVal);

				// 可购量 不满足 最小起购量
				if (this.max < this.min) {
					this.currentValue = this.isTimedSaleSpec ? 0 : this.max;

					let msg = (isPlus || newVal > this.max) ? `不能再多了` : "不能再少了"
					this.$message.error(msg);

					this.$emit('change', this.currentValue, this.cartId);
					return
				}

				let errmsg = '';

				if (newVal < this.min) {
					errmsg = this.currentValue != 0 && "不能再少了" || '';
					newVal = this.min;
				}
				if (newVal > this.max) {
					errmsg = "不能再多了";
					newVal = this.max;
				}

				// 判断当前值是否满足 最小起购量 和 单次购买倍数
				if (newVal > 0 && (newVal - this.min) % this.step > 0) {
					errmsg = "购买数量必须为单次购买量" + this.step + "的倍数加最小起购量" + this.min;
					newVal = this.min + this.step * parseInt((newVal - this.min) / this.step);
				}
				// 提示错误信息
				errmsg && this.$message.error(errmsg)

				this.currentValue = newVal;
				this.$emit('change', newVal, this.cartId);
			}
		}
	}
</script>

<style scoped="scoped">
	.i-content {
		align-items: center;
		width: 87px;
		height: 30px;
		border: 1px solid #DCDFE6;
		border-radius: 6px;
		margin: 9px 0;
	}

	/* 	.i-span {
		margin-left: 9px;
		font-size: 8px;
		border: 1px solid #DCDFE6;
	} */

	.i-span {
		font-size: 12px;
		border: 1px solid #dcdfe6;
		padding: 2px;
		cursor: pointer;
		margin: 1px 0 1px 9px;
		line-height: 12px;
		text-align: center;
		height: 12px;
		width: 12px;
		border-radius: 2px;
	}

	.i-input {
		height: 26px;
		width: 81px;
		border: none;
		text-align: center;
		font-size: 15px;
	}

	.i-input:focus {
		outline: none;
	}

	.i-horizontal-content {
		display: flex;
		justify-content: space-around;
		cursor: pointer;
	}

	.i-input-horizontal {
		height: 33px;
		border: 1px solid #DCDFE6;
		border-radius: unset;
		width: 80%;
	}

	.i-span-horizontal {
		border: 1px solid #dcdfe6;
		font-size: 13px;
		padding: 10px;
		/* cursor: pointer; */
		border-radius: 4px;
		width: 10%;
	}

	.horizontal-right {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		margin-left: -1px;
	}

	.horizontal-left {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		margin-right: -1px;
	}

	.disabled-input {
		background-color: #F5F7FA;
		cursor: not-allowed;
	}
</style>